export function accountDocument() {
  const $accountDocument = $('.account-document');
  if (!$accountDocument || $accountDocument.length === 0) return;

  const $fileRemove = $('.account-document-file-remove');
  const $input = $('.account-document-file-upload-input');

  $fileRemove.on('click', (e) => {
    e.preventDefault();

    const $t = $(e.currentTarget);
    $t.parents('.account-document-file').addClass('hide-preview');
  });

  $input.on('change', (e) => {
    const $t = $(e.currentTarget);
    const $parent = $t.parents('.account-document-file');
    const $image = $parent.find('.account-document-file-preview-image');
    const $link = $image.parents('a');
    const reader = new FileReader();
    const file = $t.get(0).files[0];

    reader.onloadend = () => {
      $image.attr('src', reader.result);
      $link.attr('href', URL.createObjectURL(file));
    };

    if (file) {
      reader.readAsDataURL(file);
      $parent.removeClass('hide-preview');
    } else {
      $image.attr('src', '');
      $parent.addClass('hide-preview');
    }
  });
}
